import React from "react";
import { Link } from "react-router-dom";
import { FileText, Search, Flower2, HelpCircle, ArrowRight } from "lucide-react";
import Card from "../../../components/common/Card";

const FeaturesSection = () => {
  const features = [
    {
      icon: FileText,
      title: "부고 작성",
      description: "간편하게 부고를 작성하고 공유하세요",
      link: "/obituaries/create",
      iconColor: "text-blue-600",
      iconBg: "bg-blue-50 group-hover:bg-blue-100",
    },
    {
      icon: Search,
      title: "부고 찾기",
      description: "지인의 부고를 검색하고 확인하세요",
      link: "/obituaries",
      iconColor: "text-green-600",
      iconBg: "bg-green-50 group-hover:bg-green-100",
    },
    {
      icon: Flower2,
      title: "화환 보내기",
      description: "마음을 담은 화환을 보내세요",
      link: "/wreaths",
      iconColor: "text-purple-600",
      iconBg: "bg-purple-50 group-hover:bg-purple-100",
    },
    {
      icon: HelpCircle,
      title: "고객 지원",
      description: "자주 묻는 질문과 문의하기",
      link: "/support",
      iconColor: "text-orange-600",
      iconBg: "bg-orange-50 group-hover:bg-orange-100",
    },
  ];

  return (
    <section className="py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-charcoal text-center mb-12">
          주요 서비스
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <Link
                key={index}
                to={feature.link}
                className="group rounded-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2"
              >
                <Card className="h-full hover:shadow-lg transition-shadow cursor-pointer">
                  <div className="p-6 text-center">
                    <div className="mb-4 flex justify-center">
                      <div
                        className={`w-16 h-16 ${feature.iconBg} rounded-full flex items-center justify-center transition-all duration-200 group-hover:scale-110`}
                      >
                        <Icon size={32} className={feature.iconColor} />
                      </div>
                    </div>
                    <h3 className="text-xl font-semibold text-charcoal mb-2">
                      {feature.title}
                    </h3>
                    <p className="text-gray-600">{feature.description}</p>
                    <span className="mt-3 inline-flex items-center justify-center gap-1 text-sm font-medium text-primary-700 opacity-0 -translate-x-2 transition-all duration-200 group-hover:opacity-100 group-hover:translate-x-0">
                      바로가기
                      <ArrowRight size={16} />
                    </span>
                  </div>
                </Card>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
